import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'tr', label: 'TR' },
  { code: 'en', label: 'EN' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.split('-')[0] || 'tr';

  return (
    <div className="flex items-center gap-0.5">
      {LANGUAGES.map(({ code, label }, idx) => (
        <React.Fragment key={code}>
          {idx > 0 && (
            <span className="text-gray-300 text-xs select-none">|</span>
          )}
          <button
            onClick={() => i18n.changeLanguage(code)}
            className={`text-xs font-semibold px-1.5 py-0.5 rounded transition-colors ${
              currentLang === code
                ? 'text-blue-600'
                : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            {label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
